import axios from 'axios';

class GuloggratisApi {
	install (vue) {
		vue.prototype.$guloggratisApi = this;
		this.url = process.env.VUE_APP_GULOGGRATIS_API_BASE;
	}
	get (route) {
		return new Promise((resolve, reject) => {
			let url = this.url + route;
			axios({method: 'GET', url: url})
			.then(response => {
				if (typeof response.data !== 'undefined' && typeof response.status !== 'undefined' && response.status === 200) {
					resolve(response.data)
				} else {
					reject(new Error('An error occured, please try again'))
				}
			}).catch(error => {
				reject(error)
			})
		})
	}
}

const guloggratisApi = new GuloggratisApi();
export default guloggratisApi;

